<div class="feedback-form-container">
  <h3>Give Feedback</h3>
  <p>What additional feedback would you like to include about the response?</p>
  <form [formGroup]="feedbackForm">
    <kendo-formfield>
      <kendo-dropdownlist
        formControlName="reason"
        [data]="reasons"
      ></kendo-dropdownlist>
    </kendo-formfield>
    <kendo-formfield>
      <div class="mt-3">
        <kendo-label
          [for]="formComments"
          text="Comments (optional)"
        ></kendo-label>
        <kendo-textarea
          #formComments
          resizable="none"
          rows="10"
          [maxlength]="commentsMaxLength"
          placeholder="Enter Comments"
          formControlName="comments"
        >
          <kendo-textarea-suffix class="kehe-textarea-counter">
            {{ characterCounter.text$ | async }}
          </kendo-textarea-suffix>
        </kendo-textarea>
      </div>
    </kendo-formfield>
  </form>

  <div class="actions">
    <kehe-phoenix-button classAttr="btn-secondary" (click)="onCancelClick()"
      >Cancel</kehe-phoenix-button
    >
    <kehe-phoenix-button
      class="ms-2"
      classAttr="btn-primary"
      (click)="onSubmitClick()"
      >Submit</kehe-phoenix-button
    >
  </div>
</div>
